import types from '../constants/actionTypes';
import { Map, List, OrderedSet } from 'immutable';

const users = (state, action) => {
  switch (action.type) {
    case types.dataFetching.USERS_REQUEST:
    case types.dataFetching.SAVE_USER_REQUEST:
    case types.dataFetching.CREATE_USER_REQUEST:
    case types.dataFetching.DELETE_USER_REQUEST:
      state = state.set('isFetching', true);
      break;
    case types.dataFetching.USERS_REQUEST_SUCCESS:
      state = state.merge({
        isFetching: false,
        items: action.payload.entities.users,
        result: action.payload.result,
      });
      break;
    case types.dataFetching.USERS_REQUEST_ERROR:
    case types.dataFetching.SAVE_USER_REQUEST_ERROR:
    case types.dataFetching.CREATE_USER_ERROR:
    case types.dataFetching.DELETE_USER_ERROR:
      state = state.set('isFetching', false);
      break;
    case types.dataFetching.SAVE_USER_REQUEST_SUCCESS:
      state = state.mergeIn(['items'], action.payload.entities.users);
      state = state.set('isFetching', false);
      break;
    case types.users.REQUEST_EDIT_USER:
      state = state.setIn(['items', `${action.userId}`, 'editing'], true);
      break;
    case types.users.REQUEST_ADD_USER:
      const newKey = -1;
      if (state.get('result').indexOf(newKey) !== -1) break;
      state = state.mergeIn(['items', newKey.toString()],
        Map({
          firstName: '',
          lastName: '',
          email: '',
          editing: false,
          admin: false,
        })
      );
      state = state.updateIn(['result'], result => result.push(newKey));
      break;
    case types.users.CANCEL_ADD_USER:
      state = state.updateIn(['result'], result => result.delete(state.get('result').indexOf(-1)));
      state = state.deleteIn(['items', '-1']);
      break;
    case types.users.CHANGE_NEW_USER_ATTRIBUTE:
      state = state.setIn(['items', '-1', action.attribute], action.value);
      break;
    case types.users.CANCEL_EDIT_USER:
      state = state.deleteIn(['items', `${action.userId}`, 'editing']);
      break;
    case types.dataFetching.CREATE_USER_SUCCESS:
      state = state.mergeIn(['items'], action.payload.entities.users);
      state = state.updateIn(['result'], result => result.push(action.payload.result));
      state = state.set('isFetching', false);

      // Clear new temporary record
      state = state.updateIn(['result'], result => result.delete(state.get('result').indexOf(-1)));
      state = state.deleteIn(['items', '-1']);
      break;
    case types.dataFetching.DELETE_USER_SUCCESS:
      state = state.deleteIn(['items', action.payload.result]);
      state = state.updateIn(['result'], result => result.delete(state.get('result').indexOf(action.payload.result)));
      state = state.set('isFetching', false);
      break;
  }
  return state;
};

export default users;



/** WEBPACK FOOTER **
 ** ./reducers/users.js
 **/